"use client"

import Image from "next/image"
import Box from "@mui/material/Box"

export const NO_IMAGE = "/assets/images/no-image-placeholder.png"

const FULL_CLASS = "next-image-full"

const NextImage = props => {
  const {
    src,
    alt = "",
    sx,
    priority,
    width,
    height,
    sizes,
    loading,
    onLoad,
    style,
    layout: _layout,
    objectFit,
    className,
    ...rest
  } = props

  const useFill = _layout === "fill" || !(width && height)
  const resolvedLoading = priority ? "eager" : loading || "lazy"
  const resolvedSrc = src || NO_IMAGE

  return (
    <Box
      className={className}
      sx={{
        position: "relative",
        display: useFill ? "block" : "inline-block",
        backgroundColor: "grey.100",
        [`& .${FULL_CLASS}`]: {
          objectFit: objectFit ?? "cover",
          objectPosition: "center"
        },
        ...sx
      }}
    >
      {/* Native lazy loading preserves SSR image discovery without downloading
          an original-size remote image as a pretend tiny placeholder. */}
      <Image
        fill={useFill}
        width={useFill ? undefined : width}
        height={useFill ? undefined : height}
        priority={priority}
        loading={resolvedLoading}
        src={resolvedSrc}
        alt={alt || "image"}
        sizes={sizes}
        onLoad={onLoad}
        className={FULL_CLASS}
        style={style}
        {...rest}
      />
    </Box>
  )
}

export default NextImage
